module.exports = __webpack_public_path__ + "static/img/left.b9bece6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/us/left.jpg
// module id = NhJh
// module chunks = 1